import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { getOptionsList, getVehicleClasses } from 'services/types';
import { Multiselect, Select } from './fields';
import { MultiInput } from './multi-input';

export const ClassFilter = (props) => {
  const { name = 'vehicle_class', multiple, ...rest } = props;
  const { t } = useTranslation();
  const title = t('dict_filter.Класс ТС');

  const items = getVehicleClasses();

  // multiple
  if (multiple) {
    return <Multiselect type="multiselect" label={title} additionalComponent={MultiInput} data={items} countDisplayedIcons={1} width={'200px'} name={name} {...rest} />;
  }

  // single
  const itemsEl = getOptionsList(items);

  return (
    <Select name={name} type="select" label={title} {...rest}>
      <option value="">{t('filter.Все')}</option>
      {itemsEl}
    </Select>
  );
};

ClassFilter.propTypes = {
  name: PropTypes.string,
  multiple: PropTypes.bool,
};
